var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeafEco = function SvgLeafEco(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4,
    d: "M1.748 18.853c.45-4.556 2.25-8.1 6.3-10.125m-2.7 7.088c5.596 0 9.45-3.33 9.9-12.15V1.64h-3.613c-8.1 0-10.787 4.05-10.8 9.112 0 1.013 0 3.038 1.8 5.063h2.713Z"
  })));
};
export { SvgLeafEco as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTEuNzQ4IDE4Ljg1M2MuNDUtNC41NTYgMi4yNS04LjEgNi4zLTEwLjEyNW0tMi43IDcuMDg4YzUuNTk2IDAgOS40NS0zLjMzIDkuOS0xMi4xNVYxLjY0aC0zLjYxM2MtOC4xIDAtMTAuNzg3IDQuMDUtMTAuOCA5LjExMiAwIDEuMDEzIDAgMy4wMzggMS44IDUuMDYzaDIuNzEzWiIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMS40IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz48L3N2Zz4=";